export var docTypes = {
    DNI: {
        label: 'DNI',
        validator: /^[1-9]\d{6,7}$/
    }
};
//# sourceMappingURL=docTypes.js.map